// extracted by mini-css-extract-plugin
export default {"player":"Player_player__29xth","bgImg":"Player_bgImg__2Smgn","audio":"Player_audio__Z7AHS"};